import { useState } from 'react';
import Constants from 'common/Constants';
import CommonStyles from 'common/CommonStyles';
import CommonBridge from 'common/CommonBridge';
import Env from '@mi/duplo-env-rn';
import { AsyncStorage } from 'utils/Community';
import Url from 'url';
/**
 * url的参数解析为字符串对象
 * @param {String} url
 * @return {Object}
 */
const parseQueryString = (url) => {
  let arr;
  const res = {};
  // #符号之后的值称为hash，都不会加到request请求中去
  url = url.split('#')[0];
  // 获取queryString 第一个？号后面的全是查询字符串
  arr = url.split('?');
  arr.shift();
  const queryStr = arr.join('?');
  // 查询字符串为空直接返回 避免出现这样的返回值{"":""}
  if (queryStr.trim().length === 0) {
    return res;
  }

  // 获取参数
  arr = queryStr.split('&');
  for (let i = 0; i < arr.length; i++) {
    const itemArr = arr[i].split('=');
    // 第一个=号之前的是name 后面的全是值
    const name = itemArr.shift();
    const value = itemArr.join('=');
    res[name] = decodeURIComponent(value);
  }
  return res;
};

/**
 * 解析url中的host
 * @param url
 * @returns {string}
 */
const parseHost = (url) => {
  // Parse host by string manipulation instead of URL constructor
  const match = url.match(/^https?:\/\/([^\/\?:]+)([\/\?:]|$)/);
  return match ? match[1] : '';
};

/**
 *  获取url中的某个参数值
 *  @param url
 *  @param key
 */
const getUrlParamVal = (url, key) => {
  const paramsObj = {};
  const paramsArr = url.substring(url.indexOf('?') + 1, url.length).split('&');
  for (let i = 0, len = paramsArr.length; i < len; i++) {
    const param = paramsArr[i];
    const flagArr = param.split('=');
    paramsObj[flagArr[0]] = flagArr[1];
  }

  return paramsObj[key] || '';
};
/**
 * url中添加一个参数
 * @param url
 * @param param
 * @param value
 * @returns {string}
 */
const addUrlPara = (url, param, value) => {
  if (url === undefined) {
    return;
  }
  const loca = Url.parse(url, true);
  const baseUrl = loca.protocol + '//' + loca.hostname + loca.pathname;
  const query = loca.search.substring(1);
  const p = new RegExp('(^|&)' + param + '=(.*?)(?=&|$)');
  if (p.test(query)) {
    const newQuery = query.replace(p, '$1' + param + '=' + value);
    return baseUrl + '?' + newQuery;
  } else {
    if (query == '') {
      return baseUrl + '?' + param + '=' + value;
    } else {
      return baseUrl + '?' + query + '&' + param + '=' + value;
    }
  }
};
/**
 * 检查url中的source,如果没有，加上
 * @param url
 * @returns {string}
 */
const checkUrlSource = (url) => {
  if (typeof url === 'string' && Constants.source) {
    try {
      const result = Url.parse(url, true);
      if (result && result.query && (!result.query.source || result.query.source == '')) {
        // add source from Constants
        return this.addUrlPara(url, 'source', Constants.source);
      }
    } catch (e) {
      console.log(e);
    }
  }
  return url;
};
/**
 * url中删除一个参数
 * @param url
 * @param param
 * @returns {string}
 */
const urlDel = (url, param) => {
  const loca = Url.parse(url, true);
  const baseUrl = loca.protocol + '//' + loca.hostname + loca.pathname;
  const query = loca.search.substring(1);
  const p = new RegExp('(^|&)' + param + '=(.*?)(?=&|$)');
  if (p.test(query)) {
    let newQuery = query.replace(p, '');
    if (newQuery.startsWith('&')) {
      newQuery = newQuery.substring(1);
    }
    return baseUrl + '?' + newQuery;
  } else {
    if (query == '') {
      return baseUrl;
    } else {
      return baseUrl + '?' + query;
    }
  }
};

const cache = {};
const setCache = (key, value) => {
  if (CommonBridge.isWxminiprogram() && !CommonBridge.isWeb()) {
    AsyncStorage.setItemSync(key, value);
  } else {
    cache[key] = value;
  }
};

const getCache = (key) => {
  if (CommonBridge.isWxminiprogram() && !CommonBridge.isWeb()) {
    return AsyncStorage.getItemSync(key);
  } else {
    return cache[key];
  }
};
let servertime;
const setcurrentTime = (time) => {
  servertime = time;
};
const currentTimeStamp = () => {
  return servertime || new Date().getTime() / 1000;
};
// 紧急替换优惠券无门槛文案
const getCouponText = (type, bottomText) => {
  let ret = bottomText;
  if (ret === '无门槛') {
    ret = type === 0 ? '直减券' : '';
  }
  return ret;
};
const getFormatPrice = (origin, notDivide) => {
  let price = String(origin);
  const dot = price.lastIndexOf('.');
  if (dot > 0) {
    price = Number(origin).toFixed(2);
  } else if (!notDivide) {
    price = (Number(origin) / 100).toFixed(2);
  } else {
    price = Number(origin).toFixed(2);
  }
  if (price.endsWith('00')) {
    price = price.substring(0, price.length - 3);
  } else if (price.endsWith('0')) {
    price = price.substring(0, price.length - 1);
  }

  return price;
};
/**
 * url中增加etc=FFFFFF参数
 * @param url
 * @returns {string}
 */
const backgroundColorFormat = (url, color) => {
  if (!url) {
    return '';
  }

  // http to https
  if (url.indexOf('http://') > -1) {
    url = url.replace('http://', 'https://');
  }
  // 是否已经有etc单不支持变更
  if (url.indexOf('et=1&etc=') > -1) {
    return url;
  }

  // gif图片不支持webp
  if (url.indexOf('.gif') > -1) {
    return url;
  }

  // 通过域名判断是否为 kscloud
  if (url.indexOf('img.youpin.mi-img.com') > -1) {
    url = url.split('?')[0];
    if (url.indexOf('@base@tag=imgScale') === -1) {
      url = url + '@base@tag=imgScale';
    }
    url = url + '&et=1&etc=' + color;
  }
  return url;
};
const getObjProps = (obj, propStr) => {
  if (!obj) {
    return false;
  }
  propStr = propStr.trim();
  const len = propStr.length;
  const pointIndex = propStr.indexOf('.');
  if (pointIndex === -1) {
    if (obj.hasOwnProperty(propStr)) {
      return obj[propStr];
    } else {
      return false;
    }
  }
  if (pointIndex === 0 || pointIndex === len) {
    return false;
  }
  const key = propStr.substr(0, pointIndex);
  const props = propStr.substr(pointIndex + 1, len);
  if (key in obj) {
    return getObjProps(obj[key], props);
  } else {
    return false;
  }
};
/**
 * 触发jit用的空占位函数
 */
function noop() {}

// eslint-disable-next-line no-unused-vars
function getViewLength(height, isMarginTop) {
  return (height * CommonStyles.ViewWidth) / 1080;
}

// 跳转rn新域名页 TODO: 购物车新域名
function getTradeDomain() {
  if (CommonBridge.isWeb()) {
    return CommonBridge.isStaging() ? Constants.TradeStDomain : Constants.tradeUrlPrefix;
  } else {
    return Constants.tradeUrlPrefix;
  }
}

const isNullOrUndefined = (val) => {
  return val === null || typeof val === 'undefined';
};

/**
 * Array.prototype.findLast 目前在我们的RN项目中不存在
 * @param arr {array}
 * @param cb {function}
 */
const findLast = (arr, cb) => {
  if (!Array.isArray(arr) || typeof cb !== 'function') {
    return undefined;
  }

  for (let i = arr.length - 1; i >= 0; i--) {
    const item = arr[i];
    const res = item || cb(item);
    if (res) {
      return item;
    }
  }

  return undefined;
};
function useStates(stateMap) {
  const [ret, setRet] = useState(stateMap);
  Object.keys(ret).forEach((key) => {
    const funcName = 'set' + key[0].toUpperCase() + key.substring(1);
    ret[funcName] = (newval) => {
      setRet((prevState) => {
        return { ...prevState, [key]: newval };
      });
    };
  });

  return ret;
}
function needAndroidRoleWindow() {
  const timestamp = parseInt(Env.timestamp) || 0;
  return (
    (CommonBridge.isYoupinApp() || CommonBridge.isMishopApp()) && CommonBridge.isAndroid() && timestamp >= 20210319
  );
}
function visitor(obj, cb = () => {}) {
  const stack = [{ p: obj, name: 'root', path: 'root' }];
  const hash = new WeakSet();
  do {
    let count = 0;
    stack.forEach((el) => {
      if (hash.has(el.p)) {
        return;
      }
      ++count;
      const c = typeof el.p === 'object' && !!el.p ? Object.keys(el.p) : null;
      const res = cb(el.p, el.name, el.path);
      res &&
        c &&
        c.forEach((key) => {
          stack.push({
            p: el.p[key],
            name: key,
            path: /^[0-9]$/gi.test(key) ? el.path + '[' + parseInt(key) + ']' : el.path + '.' + key,
          });
        });
      if (typeof el.p === 'object' && el.p) {
        hash.add(el.p);
      }
    });
    stack.splice(0, count);
  } while (stack.length > 0);

  return obj;
}

/**
 * 数组处理：将一维数组变为N维数组
 * @param {*} arr
 * @param {*} len
 */
const splitArray = (arr, len) => {
  const arr_length = arr.length;
  const newArr = [];
  for (let i = 0; i < arr_length; i += len) {
    newArr.push(arr.slice(i, i + len));
  }
  return newArr;
};

const _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
const encodeBase64 = function (input) {
  let output = '';
  let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
  let i = 0;

  while (i < input.length) {
    chr1 = input.charCodeAt(i++);
    chr2 = input.charCodeAt(i++);
    chr3 = input.charCodeAt(i++);

    enc1 = chr1 >> 2;
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
    enc4 = chr3 & 63;

    if (isNaN(chr2)) {
      enc3 = enc4 = 64;
    } else if (isNaN(chr3)) {
      enc4 = 64;
    }

    output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
  }
  return output;
};
const funcs = {
  parseQueryString,
  parseHost,
  getUrlParamVal,
  addUrlPara,
  checkUrlSource,
  urlDel,
  setCache,
  getCache,
  setcurrentTime,
  currentTimeStamp,
  getCouponText,
  noop,
  getFormatPrice,
  backgroundColorFormat,
  getObjProps,
  getViewLength,
  getTradeDomain,
  isNullOrUndefined,
  findLast,
  useStates,
  needAndroidRoleWindow,
  visitor,
  splitArray,
  encodeBase64,
};
export default funcs;
